import React, { useEffect, useState } from 'react';
import { BsBarChartFill } from "react-icons/bs";
import { PiScalesFill } from "react-icons/pi";
import * as THREE from '../../../../dist/three.module.js';

import {
    fmesh,
    fullmesh,
    fmeshPoints
} from '../../../core/globalVariables';

const ScaleIndicator = ({
    isComparing,
    handleCompareClick,
    mapRef,
    globalState,
    globalRefs,
}) => {
    const [scale, setScale] = useState('');
    const [barWidth, setBarWidth] = useState('100%');

    const globalStateMapDistanceKm = globalState.globalStateMapDistanceKm;
    const setGlobalStateMapDistanceKm = globalState.setGlobalStateMapDistanceKm;

    const longstandingGeoJSONRef = globalRefs.longstandingGeoJSONRef;
    const polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;
    const selectedYearEditing = globalState.selectedYearEditing;
    const setGlobalPolygonTransparency = globalState.setGlobalPolygonTransparency;
    const setAPIReportMessage = globalState.setAPIReportMessage;

    const [pointGeometryScale, setPointGeometryScale] = useState(null);

    useEffect(() => {
        if (!mapRef.current) return;

        const map = mapRef.current;

        const updateScale = () => {
            const zoom = map.getZoom();

            const scale = 591657550.5 / Math.pow(2, zoom - 1);
            const scaleText =
                scale >= 1000
                    ? `${(scale / 1000).toFixed(0)} km`
                    : `${scale.toFixed(0)} m`;

            setScale(scaleText);
            // setGlobalStateMapDistanceKm(scale);

            const milestone = 100000000;
            const widthPercentage = ((scale % milestone) / milestone) * 100;

            setBarWidth(`${widthPercentage}%`);
        };

        map.on("zoom", updateScale);

        updateScale();

        return () => {
            map.off("zoom", updateScale);
        };
    }, []);

    useEffect(() => {
        // if (!mapRef.current) return;
        // scaleExistingPointGeometries();
        // setAPIReportMessage('')
        let pointGeometryScale = globalStateMapDistanceKm / 2000;
        scaleExistingPointGeometries(pointGeometryScale)
    }, [mapRef, globalStateMapDistanceKm, polygonCustomLayerRef, longstandingGeoJSONRef, selectedYearEditing]);

    const scaleExistingPointGeometries = (pointGeometryScale) => {
        if (!fmeshPoints) return;
        for (const child of fmeshPoints.children) {
            if (!child.userData.centered) {
                child.geometry.computeBoundingBox();
                const center = new THREE.Vector3();
                child.geometry.boundingBox.getCenter(center);
                child.geometry.translate(-center.x, -center.y, 0);
                child.position.x += center.x;
                child.position.y += center.y;
                child.userData.centered = true;
            }
            child.scale.x = pointGeometryScale;
            child.scale.y = pointGeometryScale
        }
    };

    return (
        <div style={{ position: 'absolute', bottom: '65px', left: '20%', width: '60%', height: '100px', backgroundColor: 'white' }}>
            <div>
                <div style={{
                    top: '-20px', width: '100%', textAlign: 'center', fontSize: '10px', position: 'relative'
                }}>
                    <b>Zoom: {scale}</b>
                </div>
                <div
                    style={{
                        // marginLeft: '30px',
                        borderLeft: '4px solid #000',
                        borderRight: '4px solid #000',
                        borderBottom: '4px solid #000',
                        backgroundColor: 'transparent',
                        width: barWidth,
                        height: '5px',
                        position: 'absolute',
                        top: 0,
                        left: '50%',
                        fontSize: '10px',
                        transform: 'translateX(-50%)', // center the bar
                        transformOrigin: 'center',      // scale from the center
                    }}
                ></div>
            </div>
        </div>
    );
};

export default ScaleIndicator;